module.exports = __webpack_public_path__ + "img/line.a83be5d6.svg";